/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CardTypeDTO,
    CardTypeDTOFromJSON,
    CardTypeDTOFromJSONTyped,
    CardTypeDTOToJSON,
} from './CardTypeDTO';

/**
 * 
 * @export
 * @interface CardTypeConfigurationDTO
 */
export interface CardTypeConfigurationDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CardTypeConfigurationDTO
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CardTypeConfigurationDTO
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {number}
     * @memberof CardTypeConfigurationDTO
     */
    costLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof CardTypeConfigurationDTO
     */
    costLimitPeriod?: number;
    /**
     * 
     * @type {CardTypeDTO}
     * @memberof CardTypeConfigurationDTO
     */
    cardType?: CardTypeDTO;
}

export function CardTypeConfigurationDTOFromJSON(json: any): CardTypeConfigurationDTO {
    return CardTypeConfigurationDTOFromJSONTyped(json, false);
}

export function CardTypeConfigurationDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardTypeConfigurationDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'costLimit': !exists(json, 'costLimit') ? undefined : json['costLimit'],
        'costLimitPeriod': !exists(json, 'costLimitPeriod') ? undefined : json['costLimitPeriod'],
        'cardType': !exists(json, 'cardType') ? undefined : CardTypeDTOFromJSON(json['cardType']),
    };
}

export function CardTypeConfigurationDTOToJSON(value?: CardTypeConfigurationDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'carePrincipalId': value.carePrincipalId,
        'costLimit': value.costLimit,
        'costLimitPeriod': value.costLimitPeriod,
        'cardType': CardTypeDTOToJSON(value.cardType),
    };
}

